import colors from "./colors";
import boxShadow from "../functions/boxShadow";
const { black, inputColors } = colors;
/** Restrained surface shadows; focus rings remain visible on all controls. */
const boxShadows = {
  xs: "none",
  sm: "0 2px 8px -4px rgb(11 11 12 / 10%)",
  md: "0 6px 18px -10px rgb(11 11 12 / 12%)",
  lg: "0 14px 34px -20px rgb(11 11 12 / 14%)",
  xl: "0 20px 60px -24px rgb(11 11 12 / 20%)",
  xxl: "0 14px 34px -20px rgb(11 11 12 / 14%)",
  inset: boxShadow([0, 1], [2, 0], black.main, 0.05, "inset"),
  navbarBoxShadow: "none",
  buttonBoxShadow: { main: "none", stateOf: "none", stateOfNotHover: "0 0 0 3px #e4efc5" },
  inputBoxShadow: {
    focus: boxShadow([0, 0], [0, 2], inputColors.boxShadow, 1),
    error: boxShadow([0, 0], [0, 2], inputColors.error, 0.2),
    success: boxShadow([0, 0], [0, 2], inputColors.success, 0.2),
  },
  sliderBoxShadow: { thumb: boxShadow([0, 1], [8, 0], black.main, 0.12) },
  tabsBoxShadow: { indicator: "none" },
};
export default boxShadows;
